<template>
  <div id="ms_header_downside" class="parent_div">
    <dd-header />
    <h2 class="hakotan_title">会社概要</h2>
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="corp_information">
          <section>
            <ul class="ul_corp_outline">
              <li>
                <div>会社名</div>
                <div>株式会社ヤスモク</div>
              </li>
              <li>
                <div>本社</div>
                <div>
                  〒501-4202 岐阜県郡上市八幡町市島18-1<br>
                  TEL 0575-62-2311 FAX 0575-62-2227
                </div>
              </li>
              <li>
                <div>代表者</div>
                <div>代表取締役 安田知弘</div>
              </li>
              <li>
                <div>資本金</div>
                <div>2500万円</div>
              </li>
              <li>
                <div>設立</div>
                <div>1974年6月10日（昭和49年6月10日）</div>
              </li>
              <li>
                <div>事業内容</div>
                <div>
                  住宅関連木製品の製造販売<br>
                  （システムキッチン・ウッドデッキ・インテリア・エクステリア関連商品・その他木製品）
                </div>
              </li>
              <li>
                <div>交通アクセス</div>
                <div class="traficc_access_list">
                  <div>
                    <p>本社（岐阜）：〒501-4202 岐阜県郡上市八幡町市島18-1</p>
                    <div class="gmap">
                      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d103565.04666966187!2d137.00402!3d35.789923!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6002efc630324031%3A0xfe84b7487edb1e01!2z44CSNTAxLTQyMDIg5bKQ6Zic55yM6YOh5LiK5biC5YWr5bmh55S65biC5bO277yR77yY4oiS77yR!5e0!3m2!1sja!2sjp!4v1674038082953!5m2!1sja!2sjp" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div class="gmap_route">
                      ◆郡上八幡ICより(所要時間:車約11分)<br>
                      ●八幡IC口交差点を左折、越前街道/国道156号線を南東へ<br>
                      ●城南(交差点)手前で左折、せせらぎ街道/国道256号線を北東へ<br>
                      ●八幡大橋南(交差点)を左折、橋を渡り、せせらぎ街道/国道472号線北へ<br>
                      ●下小野(交差点)を右折、せせらぎ街道/国道472号線を北東へ約4㎞<br>
                      ☆対岸に弊社の白い建物が見えてきます
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'

import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'

export default {
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcCorpInformation',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'corpInformation', key: 'dcCorpInformation', title: '会社案内', route: 'DcCorpInformation'}
      ]
    }
  },
  computed: {
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>
<style src="../css/dc-mainmenu.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcCorpInformation.vue